var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgInfoLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0617 8.44119V4.85954C11.0617 2.17569 8.79535 0 5.99967 0C3.204 0 0.937656 2.17569 0.937656 4.85954V8.44119C-0.659953 10.8522 -0.174624 14.0231 2.07789 15.891C4.33041 17.7589 7.66894 17.7589 9.92145 15.891C12.174 14.0231 12.6593 10.8522 11.0617 8.44119ZM6.74966 12.0409V13.6787C6.74966 14.0763 6.4139 14.3986 5.99973 14.3986C5.58556 14.3986 5.2498 14.0763 5.2498 13.6787V12.0394C4.6619 11.7136 4.37528 11.0493 4.55098 10.4198C4.72668 9.79031 5.32089 9.3526 5.99973 9.3526C6.67857 9.3526 7.27278 9.79031 7.44848 10.4198C7.62418 11.0493 7.33755 11.7136 6.74966 12.0394V12.0409ZM9.00989 6.34105C9.12011 6.27539 9.18715 6.15971 9.18716 6.03519V4.85954C9.18716 3.16971 7.7602 1.79983 5.99996 1.79983C4.23972 1.79983 2.81276 3.16971 2.81276 4.85954V6.03519C2.81277 6.15971 2.87981 6.27539 2.99003 6.34105C3.10025 6.4067 3.23799 6.41301 3.35421 6.35772C5.02067 5.562 6.97925 5.562 8.64571 6.35772C8.76193 6.41301 8.89967 6.4067 9.00989 6.34105Z",
    fill: "#4F6382"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgInfoLock);
export default __webpack_public_path__ + "static/media/bg_info_lock.59243f26327d28ab3715f18f17424e06.svg";
export { ForwardRef as ReactComponent };